import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Shirditosaptaracab() {



    const cardData = {





keyword: "Shirdi to Saputara Cab",

headingDescription: "Sai Shirdi Cab provides comfortable and reliable Shirdi to Saputara Cab service for families, couples, tourists, devotees, senior citizens, and groups traveling from Shirdi to Saputara for a relaxing hill-station getaway. Customers can book private chauffeur-driven Sedan, SUV, Ertiga, Innova, Innova Crysta, and other suitable vehicles for one-way journeys, round trips, weekend holidays, family vacations, and customized sightseeing tours. With experienced drivers, clean and well-maintained vehicles, comfortable seating, sufficient luggage space, flexible pickup timings, and convenient destination drops, travelers can enjoy a direct road journey without changing vehicles. The route is suitable for travelers looking to combine Saputara sightseeing with other scenic, religious, and cultural destinations across Maharashtra and Gujarat. Sai Shirdi Cab can also arrange flexible return journeys and multi-day travel plans according to the customer's itinerary.",

topPlaces: [
  {
    title: "Saputara",
    description: "Saputara is a popular hill station in Gujarat known for its pleasant surroundings, viewpoints, gardens, lakes, and scenic landscapes. Travelers from Shirdi can book a private cab for a comfortable holiday journey with convenient hotel or sightseeing drops. One-way and round-trip options are available for couples, families, and groups."
  },
  {
    title: "Nashik",
    description: "Nashik is an important religious and cultural destination that can be included before or after a Shirdi to Saputara journey. Travelers can explore temples, heritage locations, vineyards, and scenic attractions around the city. Private cab service allows customers to add Nashik to their itinerary without arranging separate transportation."
  },
  {
    title: "Trimbakeshwar",
    description: "Trimbakeshwar is a renowned Jyotirlinga pilgrimage destination near Nashik and is suitable for travelers who want to combine spiritual travel with their Saputara holiday. Devotees can include the temple as a stop during an extended itinerary from Shirdi. Sai Shirdi Cab provides comfortable private transportation for families and groups."
  },
  {
    title: "Waghai",
    description: "Waghai is an attractive destination near Saputara and serves as a convenient base for exploring forests, gardens, waterfalls, and natural attractions in the region. Travelers can include Waghai in a customized Saputara tour from Shirdi. Private cab travel makes it easier to cover multiple sightseeing locations according to the group's schedule."
  },
  {
    title: "Purna Wildlife Sanctuary",
    description: "Purna Wildlife Sanctuary offers a scenic natural environment with forests, hills, and diverse wildlife and is suitable for travelers interested in nature and outdoor experiences. Visitors extending their Saputara trip can include the sanctuary region in their itinerary. A private cab provides convenient transportation for families and small groups."
  },
  {
    title: "Shani Shingnapur",
    description: "Shani Shingnapur is a famous pilgrimage destination near Shirdi and can be included at the beginning or end of a combined religious and leisure tour. Devotees can visit the temple before continuing toward Saputara. Customers can arrange a private cab with flexible stops to combine pilgrimage and sightseeing in one journey."
  },
  {
    title: "Chhatrapati Sambhajinagar",
    description: "Chhatrapati Sambhajinagar is a major heritage and cultural destination that can be included in an extended Maharashtra tour from Shirdi. Travelers can explore historic monuments, caves, and temples before continuing toward other destinations. Sai Shirdi Cab provides spacious vehicles suitable for families and groups planning multi-day travel."
  },
  {
    title: "Dhulia",
    description: "Dhulia, also known as Dhule, is an important city in northern Maharashtra and can be considered as a convenient regional stop during an extended journey toward Gujarat. Travelers can include Dhule for family visits, business requirements, or onward travel. Private cab service offers flexible route planning and direct destination drops."
  },
  {
    title: "Daman",
    description: "Daman is a popular coastal destination known for beaches, forts, churches, and relaxed seaside surroundings. Travelers looking for an extended western India holiday can combine Saputara with Daman in a customized multi-day itinerary. A private cab allows families and groups to travel comfortably between the hill station and coastal attractions."
  },
  {
    title: "Surat",
    description: "Surat is a major commercial city in Gujarat and can be included as an additional destination for travelers extending their Shirdi to Saputara journey. Customers may travel to Surat for business, family visits, shopping, or onward connections. Private cab transportation provides convenient door-to-door travel with flexible scheduling."
  },
  {
    title: "Nashik Vineyards",
    description: "The Nashik vineyard region offers scenic countryside, agricultural landscapes, and leisure experiences and can be included in a broader Shirdi and Saputara holiday plan. Travelers can customize their route around suitable sightseeing locations. Sai Shirdi Cab provides private transportation for families and groups who prefer flexible travel rather than fixed tour schedules."
  },
  {
    title: "Igatpuri",
    description: "Igatpuri is a scenic hill destination in Maharashtra known for mountains, valleys, waterfalls, and peaceful surroundings. Travelers can combine Igatpuri with Saputara for an extended hill-station itinerary from Shirdi. Comfortable private cabs make it convenient to travel between the destinations while carrying luggage and enjoying flexible sightseeing stops."
  }
],



"services": [
{
"name": "Shirdi to Saputara Innova Cab Booking",
"description": "Shirdi to Saputara Innova Cab Booking provides a spacious private vehicle option for families and groups traveling from Shirdi to Saputara. The Innova can be arranged for sightseeing trips, tour packages, one-way travel, or return journeys according to the planned itinerary."
},
{
"name": "Shirdi to Saputara Innova Cab",
"description": "Shirdi to Saputara Innova Cab offers comfortable outstation transportation for travelers visiting Saputara from Shirdi. The vehicle is suitable for families and small groups requiring additional seating space, luggage capacity, and convenient travel throughout the journey."
},
{
"name": "Shirdi to Saputara Tour Package",
"description": "Shirdi to Saputara Tour Package combines private cab transportation with a planned journey from the spiritual town of Shirdi to the scenic hill station of Saputara. The itinerary can include sightseeing, hotel transfers, local travel, and return transportation."
},
{
"name": "Saputara Tour Packages from Shirdi",
"description": "Saputara Tour Packages from Shirdi provide flexible travel arrangements for visitors planning a hill-station trip after their Shirdi pilgrimage. Cab options can be selected according to group size, number of travel days, sightseeing requirements, and preferred return schedule."
},
{
"name": "Short Trip Saputara Nashik and Shirdi Package",
"description": "Short Trip Saputara Nashik and Shirdi Package is suitable for travelers combining spiritual visits with sightseeing across Saputara and Nashik. Private cab transportation can cover the complete itinerary with convenient transfers between temples, attractions, hotels, and return destinations."
},
{
"name": "Saputara Tour Package from Shirdi Nashik",
"description": "Saputara Tour Package from Shirdi Nashik offers a multi-destination travel option covering Shirdi, Nashik, and Saputara. The journey can be customized for families and groups with private cab transportation, sightseeing stops, accommodation transfers, and planned return travel."
},
{
"name": "Shirdi to Saputara Tempo Traveller on Rent",
"description": "Shirdi to Saputara Tempo Traveller on Rent is suitable for larger families and groups traveling together to Saputara. Spacious Tempo Traveller options can be arranged for sightseeing, multi-day tours, group trips, luggage requirements, and return journeys."
},
{
"name": "Shirdi to Saputara Ertiga on Rent",
"description": "Shirdi to Saputara Ertiga on Rent provides a practical seven-seater cab option for families and small groups. The vehicle can be arranged for direct outstation travel, Saputara sightseeing, tour packages, and round-trip journeys from Shirdi."
},
{
"name": "Shirdi to Saputara Sedan Cab on Rent",
"description": "Shirdi to Saputara Sedan Cab on Rent offers private transportation for individuals and smaller groups traveling to Saputara. Sedan cabs can be arranged for comfortable one-way travel, sightseeing tours, weekend trips, and return journeys."
},
{
"name": "Shirdi to Saputara Taxi",
"description": "Shirdi to Saputara Taxi provides convenient private transportation between Shirdi and Saputara for travelers planning a scenic outstation journey. The taxi can be used for direct transfers, family travel, sightseeing, tour packages, and return trips."
},
{
"name": "Shirdi to Saputara Taxi - Lowest Fare Guarantee",
"description": "Shirdi to Saputara Taxi - Lowest Fare Guarantee targets travelers comparing transportation options for their journey to Saputara. Cab selection can be based on vehicle category, passenger capacity, trip type, travel duration, and the overall requirements of the planned itinerary."
},
{
"name": "Shirdi to Saputara Mini Bus on Rent",
"description": "Shirdi to Saputara Mini Bus on Rent provides group transportation for larger parties traveling from Shirdi to Saputara. Mini buses can be arranged for family tours, group sightseeing, multi-day packages, pilgrimage combinations, and return travel."
},
{
"name": "Shirdi to Saputara 2 Day Package",
"description": "Shirdi to Saputara 2 Day Package gives travelers additional time to enjoy Saputara and nearby attractions at a comfortable pace. Private cab transportation can cover the journey from Shirdi, local sightseeing, hotel transfers, and return travel."
},
{
"name": "3 Days Trip to Saputara",
"description": "3 Days Trip to Saputara is suitable for travelers planning a relaxed hill-station getaway from Shirdi. The cab itinerary can include Saputara sightseeing, nearby attractions, accommodation transfers, local travel, and convenient transportation throughout the three-day trip."
},
{
"name": "Shirdi to Saputara Sedan Cab",
"description": "Shirdi to Saputara Sedan Cab offers a comfortable private travel option for individuals, couples, and small families. Sedan transportation can be arranged for one-way transfers, round trips, sightseeing packages, weekend travel, and customized Saputara itineraries."
},
{
"name": "Book Shirdi to Saputara Cabs - Affordable Taxi Service",
"description": "Book Shirdi to Saputara Cabs - Affordable Taxi Service provides a practical way to arrange private transportation for the scenic journey. Customers can select a suitable vehicle for family travel, sightseeing, one-way transfers, or round-trip Saputara tours."
},
{
"name": "Shirdi to Saputara Swift Dzire Tour",
"description": "Shirdi to Saputara Swift Dzire Tour provides a sedan travel option for passengers planning a comfortable journey to Saputara. The Swift Dzire can be arranged for sightseeing, short trips, one-way travel, or return tour packages from Shirdi."
}
],
"tableData": [
["Shirdi to Saputara Innova Cab Booking", "Shirdi to Saputara Innova Cab"],
["Shirdi to Saputara Tour Package", "Saputara Tour Packages from Shirdi"],
["Short Trip Saputara Nashik and Shirdi Package", "Saputara Tour Package from Shirdi Nashik"],
["Shirdi to Saputara Tempo Traveller on Rent", "Shirdi to Saputara Ertiga on Rent"],
["Shirdi to Saputara Sedan Cab on Rent", "Shirdi to Saputara Taxi"],
["Shirdi to Saputara Taxi - Lowest Fare Guarantee", "Shirdi to Saputara Mini Bus on Rent"],
["Shirdi to Saputara 2 Day Package", "3 Days Trip to Saputara"],
["Shirdi to Saputara Sedan Cab", "Book Shirdi to Saputara Cabs - Affordable Taxi Service"],
["Shirdi to Saputara Swift Dzire Tour", "Shirdi to Saputara Tour Package"]
],











        whychoose: [
            { 
                WhyChooseheading: "Scenic Shirdi to Saputara Cab Journey", 
                WhyChoosedescription: "Sai Shirdi Cabs offers private cab transportation from Shirdi to Saputara for families, couples, friends, tourists, and devotees extending their trip into a hill-station holiday. A dedicated taxi provides a convenient way to travel with your own group, luggage, and planned stops." 
            }, 
            { 
                WhyChooseheading: "Start Directly from Your Shirdi Stay", 
                WhyChoosedescription: "Arrange pickup from your hotel, residence, temple area, railway station surroundings, or another accessible location in Shirdi. Starting the journey from a preferred point can make the transition from pilgrimage to leisure travel more convenient." 
            }, 
            { 
                WhyChooseheading: "Great for Family Holidays & Weekend Trips", 
                WhyChoosedescription: "Families and groups planning a Saputara getaway can select a private cab according to their passenger count and luggage requirements. Travelling together allows everyone to follow the same schedule throughout the intercity journey." 
            }, 
            { 
                WhyChooseheading: "Continue Your Trip After Sai Darshan", 
                WhyChoosedescription: "Travellers completing their Sai Baba Darshan can continue towards Saputara without arranging separate transportation. The cab can be scheduled around your Shirdi stay, temple visit, and preferred departure time." 
            }, 
            { 
                WhyChooseheading: "One-Way Cab to Saputara", 
                WhyChoosedescription: "If Saputara is your next destination, choose a one-way cab from Shirdi for direct transportation. This option works well for travellers who have separate arrangements for their onward or return journey." 
            }, 
            { 
                WhyChooseheading: "Round-Trip Travel for a Flexible Itinerary", 
                WhyChoosedescription: "Travellers who want transportation for both directions can discuss a round-trip cab arrangement. The return schedule can be planned around the duration of your Saputara stay and overall holiday itinerary." 
            }, 
            { 
                WhyChooseheading: "Comfortable Vehicles for the Highway Journey", 
                WhyChoosedescription: "Passengers can enquire about sedan, Ertiga, Innova, Innova Crysta, SUV, or larger vehicle options based on group size, luggage, and preferred space for the longer journey towards Saputara." 
            }, 
            { 
                WhyChooseheading: "Book Shirdi to Saputara Cab with Sai Shirdi Cabs", 
                WhyChoosedescription: "Provide your Shirdi pickup location, Saputara destination, travel date, passenger count, luggage details, preferred vehicle, and one-way or return requirement to Sai Shirdi Cabs for a suitable private cab arrangement." 
            } 
        ] 
 
    }; 
 
    const faqData = [ 
        { 
            question: "Can I book a cab from Shirdi to Saputara?", 
            answer: "Yes, Sai Shirdi Cabs provides private cab services from Shirdi to Saputara for families, couples, tourists, friends, and travellers planning an intercity holiday." 
        }, 
        { 
            question: "Can I get pickup from my hotel in Shirdi?", 
            answer: "Yes, passengers can arrange pickup from their Shirdi hotel, residence, temple area, railway station surroundings, or another convenient location for the journey to Saputara." 
        }, 
        { 
            question: "Is Shirdi to Saputara Cab suitable for a family trip?", 
            answer: "Yes, families can select a suitable private vehicle according to passenger numbers, luggage requirements, and preferred comfort level for the journey." 
        }, 
        { 
            question: "Can I travel to Saputara after Sai Baba Darshan?", 
            answer: "Yes, travellers can schedule a private cab from Shirdi to Saputara after completing Sai Baba Darshan and other planned activities in Shirdi." 
        }, 
        { 
            question: "Do you provide one-way Shirdi to Saputara Cab service?", 
            answer: "Yes, one-way cab service is available for passengers who need direct transportation from Shirdi to Saputara without requiring the same vehicle for their return journey." 
        }, 
        { 
            question: "Can I book a return cab from Saputara to Shirdi?", 
            answer: "Yes, return cab arrangements can be discussed for travellers who want transportation back towards Shirdi after completing their Saputara holiday." 
        }, 
        { 
            question: "Which vehicles can I book for Shirdi to Saputara travel?", 
            answer: "Vehicle options may include sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and larger vehicles depending on passenger count, luggage, and travel requirements." 
        }, 
        { 
            question: "Can I carry luggage in the Shirdi to Saputara taxi?", 
            answer: "Yes, passengers can carry luggage according to the storage capacity of the selected vehicle. Bulky or additional baggage should be mentioned during booking." 
        }, 
        { 
            question: "Can I include sightseeing stops on the way to Saputara?", 
            answer: "Sightseeing or additional stops can be discussed while planning the trip. The itinerary should be shared in advance so the route and travel requirements can be considered." 
        }, 
        { 
            question: "How can I book Shirdi to Saputara Cab with Sai Shirdi Cabs?", 
            answer: "Share your Shirdi pickup point, Saputara destination, travel date, passenger details, luggage requirements, preferred vehicle, and one-way or return preference with Sai Shirdi Cabs to proceed with the booking." 
        } 
    ]; 
 
    const testimonials = [ 
        { 
            id: 1, 
            name: "Mr. Rohit More", 
            feedback: "After completing Sai Baba Darshan, our family continued to Saputara for a short holiday. Booking a private cab helped us travel directly with our luggage and keep our family together throughout the journey.", 
            rating: 5 
        }, 
        { 
            id: 2, 
            name: "Mrs. Snehal Patil", 
            feedback: "We planned a Shirdi and Saputara trip with friends and preferred a private taxi for the intercity travel. Having our own vehicle made the overall itinerary much easier to organize.", 
            rating: 5 
        } 
    ];



    const Images = [
        { place: "/images/keyword/1.jpg", text: "Nagarsol to Shirdi Cab", link: "Nagarsol-to-Shirdi-Cab" },
        { place: "/images/keyword/2.jpg", text: "Shirdi Cab Service", link: "Shirdi-Cab-Service" },
        { place: "/images/keyword/3.jpg", text: "Shirdi to Shani Shingnapur Cab", link: "Shirdi-to-Shani-Shingnapur-Cab" },
        { place: "/images/keyword/4.jpg", text: "Shirdi to Grishneshwar Cab", link: "Shirdi-to-Grishneshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Shirdi to Manmad Cab", link: "Shirdi-to-Manmad-Cab" },
        { place: "/images/keyword/6.jpg", text: "Shirdi to Lonavala Cab", link: "Shirdi-to-Lonavala-Cab" },
        { place: "/images/keyword/7.jpg", text: "Shirdi to Mahabaleshwar Cab", link: "Shirdi-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/8.jpg", text: "Shirdi to Ashtavinayak Darshan Package", link: "Shirdi-to-Ashtavinayak-Darshan-Package" },
        { place: "/images/keyword/9.jpg", text: "Shirdi to Saptashrungi Cab", link: "Shirdi-to-Saptashrungi-Cab" },
        { place: "/images/keyword/10.jpg", text: "Shirdi Tour Package", link: "Shirdi-Tour-Package" },
        { place: "/images/keyword/11.jpg", text: "Best Taxi Service in Shirdi", link: "Best-Taxi-Service-in-Shirdi" },
        { place: "/images/keyword/12.jpg", text: "Shirdi Airport Cab Service", link: "Shirdi-Airport-Cab-Service" },
        { place: "/images/keyword/13.jpg", text: "Online Cab Booking Shirdi", link: "Online-Cab-Booking-Shirdi" },
        { place: "/images/keyword/14.jpg", text: "Best Travel Agency in Shirdi", link: "Best-Travel-Agency-in-Shirdi" },
        { place: "/images/keyword/15.jpg", text: "Shirdi to Mumbai Airport Cab", link: "Shirdi-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/16.jpg", text: "Kopargaon to Shirdi Cab", link: "Kopargaon-to-Shirdi-Cab" },
        { place: "/images/keyword/17.jpg", text: "Innova on Rent in Shirdi", link: "Innova-on-Rent-in-Shirdi" },
        { place: "/images/keyword/18.jpg", text: "Shirdi Sightseeing Cab", link: "Shirdi-Sightseeing-Cab" },
        { place: "/images/keyword/19.jpg", text: "Shirdi Darshan Taxi", link: "Shirdi-Darshan-Taxi" },
        { place: "/images/keyword/20.jpg", text: "Bus on Hire in Shirdi", link: "Bus-on-Hire-in-Shirdi" },
        { place: "/images/keyword/21.jpg", text: "Best Sedan Cab in Shirdi", link: "Best-Sedan-Cab-in-Shirdi" },
        { place: "/images/keyword/22.jpg", text: "Ertiga Car Hire in Shirdi", link: "Ertiga-Car-Hire-in-Shirdi" },
        { place: "/images/keyword/23.jpg", text: "Innova Crysta on Rent in Shirdi", link: "Innova-Crysta-on-Rent-in-Shirdi" },
        { place: "/images/keyword/24.jpg", text: "Mini Bus on Rent in Shirdi", link: "Mini-Bus-on-Rent-in-Shirdi" },
        { place: "/images/keyword/25.jpg", text: "Tempo Traveller Hire in Shirdi", link: "Tempo-Traveller-Hire-in-Shirdi" },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Shirdi to Saputara Cab",
  "image": "https://www.saishirdicabs.com/assets/images/shirdi-to-saputara-cab.webp",
  "description":
    "Book Shirdi to Saputara Cab with Sai Shirdi Cabs for safe, comfortable, and affordable outstation taxi services. We provide Innova, Ertiga, Sedan, Tempo Traveller, and Mini Bus options for Saputara tours from Shirdi, Nashik, and nearby destinations. Enjoy one-way, round-trip, and customized tour packages with professional drivers for family trips, group travel, sightseeing, and weekend getaways to Saputara.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Shirdi Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.saishirdicabs.com/shirdi-to-saputara-cab"
  }
};





    return (
        <div>

<Helmet>
  <title>Shirdi to Saputara Cab | Taxi Fare & Tour Package | +91 7776814559</title>

  <meta
    name="description"
    content="Book Shirdi to Saputara Cab with Sai Shirdi Cabs for affordable one-way, round-trip and tour package services. Hire Innova, Ertiga, Sedan, Tempo Traveller and Mini Bus for Saputara trips from Shirdi and Nashik with professional drivers."
  />

  <meta
    name="keywords"
    content="Shirdi To Saputara Innova Cab Booking, Shirdi to Saputara Innova Cab, Shirdi to Saputara Tour Package, Saputara Tour Packages From Shirdi, Short Trip Saputara Nashik and Shirdi Package, Saputara Tour Package from Shirdi Nashik, Shirdi to Saputara Tempo Traveller on Rent, Shirdi to Saputara Ertiga on Rent, Shirdi to Saputara Sedan Cab on Rent, Shirdi to Saputara Taxi, Shirdi to Saputara Taxi Lowest Fare Guarantee, Shirdi to Saputara Mini Bus on Rent, Shirdi to Saputara Cab, Shirdi to Saputara Taxi Service, Shirdi to Saputara Cab Fare, Shirdi to Saputara One Way Cab, Shirdi to Saputara Round Trip Cab, Shirdi to Saputara Outstation Taxi, Saputara to Shirdi Cab, Saputara to Shirdi Taxi, Saputara to Shirdi One Way Cab, Saputara to Shirdi Round Trip Taxi, Shirdi Saputara Cab Booking, Shirdi Saputara Taxi Booking, Shirdi to Saputara Innova Taxi, Shirdi to Saputara Ertiga Taxi, Shirdi to Saputara Sedan Taxi, Shirdi to Saputara Tempo Traveller, Shirdi to Saputara Mini Bus Rental, Shirdi to Saputara Family Cab, Shirdi to Saputara Group Taxi, Shirdi to Saputara Tour Taxi, Shirdi to Saputara Sightseeing Cab, Saputara Tour Package from Shirdi, Saputara Nashik Shirdi Tour Package, Shirdi Nashik Saputara Cab Package, Affordable Shirdi to Saputara Cab, Best Cab Service Shirdi to Saputara, Shirdi to Saputara Weekend Tour, Shirdi to Saputara Car Rental"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/26.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Sai Shirdi Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Sai Shirdi Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Shirdi Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917776814559" className="pc-call">+91 7776814559 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919579032227" className="pc-call">+91 9579032227 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91917776814559 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917776814559 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@saishirdicabs.com" className="pc-email">
                                            booking@saishirdicabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Sai Shirdi Cabs</strong><br />
                                            Sai Mandir Lene, Near Hotel Sai Kanhaiya,
                                            Shirdi,Tel - Rahata,Dist Ahilyanagar,
                                            Maharashtra, India - 423109




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Shirditosaptaracab;